import { createWebHistory, createRouter } from 'vue-router'
import Homepage from '../views/Homepage.vue'
import error404 from '../views/error404.vue'
import Marketplace from '../views/Marketplace.vue'
import ViticulteursMarket from '../views/Marketplace/AVM.vue'
import DansTonJardin from '../views/Marketplace/DTJ.vue'
import Fleet from '../views/Fleet.vue'
import FleetClients from '../views/TemoignagesClients/FleetClients.vue'
import EchangeSemences from '@/views/EchangeSemences/EchangeSemences.vue'
import EchangeSemencesCoop from '@/views/EchangeSemences/EchangeSemencesCoop.vue'
import EchangeSemencesAgri from '@/views/EchangeSemences/EchangeSemencesAgri.vue'
import ContactUs from '@/views/ContactUs.vue'
import ContactDemo from '@/views/ContactDemo.vue'
import News from '@/views/News.vue'
import Apropos from '@/views/Apropos.vue'
import Jobs from '@/views/Jobs.vue'
import BourseVivescia from '@/views/Actus/bourse-vivescia.vue'
import DigitAppro from '@/views/DigitAppro.vue'
import NovaCollecte from '@/views/NovaCollecte.vue'
import Clients from '@/views/Clients.vue'
import PartHome from '@/views/Partner/PartHome.vue'
import DigitApproTerms from '@/views/DigitApproTerms.vue'
import Agrivitechpourleclimat from '@/views/Agrivitechpourleclimat.vue'

import RgpdDapCeresia from '@/views/RGPDApps/DAPCeresia.vue'
import RgpdDapVivescia from '@/views/RGPDApps/DAPVivescia.vue'
import RgpdDapNovagrain from '@/views/RGPDApps/DAPNovagrain.vue'
import RgpdNovSepacCompagri from '@/views/RGPDApps/NOVSepacCompagri.vue'
import rgpdFleet from '@/views/RGPDApps/FLEETAgriVitech.vue'

import DocNovaCollecte from '@/views/NovaCollecte/Documentation.vue'

import Login2 from '@/views/Logged/Login2.vue'
import Me from '@/views/Logged/Me.vue'
import Admin from '@/views/Logged/Admin.vue'
import Register from '@/views/Logged/Register.vue'
import User from '@/components/LoggedComp/User.vue'
import UserList from '@/components/LoggedComp/UserList.vue'
import EmailResetPassword from '@/views/Logged/EmailResetPassword.vue'
import ResetPassword from '@/views/Logged/ResetPassword.vue'


const history = createWebHistory();

const routes = [
    {
        path: "/",
        name: "Homepage",
        component: Homepage
    },
    {
        path: "/404",
        name: "error404",
        component: error404
    },
    {
        path: "/solutions/digitappro",
        name: "DigitAppro",
        component: DigitAppro
    },
    {
        path: "/solutions/novacollecte",
        name: "NovaCollecte",
        component: NovaCollecte
    },
    {
        path: "/solutions/digitappro/rgpd",
        name: "Confidentialité des données DigitAppro",
        component: DigitApproTerms
    },
    {
        path: "/rgpd/dap/ceresia",
        name: "Confidentialité des données DigitAppro Cérèsia",
        component: RgpdDapCeresia
    },
    {
        path: "/rgpd/dap/vivescia",
        name: "Confidentialité des données DigitAppro Vivescia",
        component: RgpdDapVivescia
    },
    {
        path: "/rgpd/dap/novagrain",
        name: "Confidentialité des données DigitAppro Novagrain",
        component: RgpdDapNovagrain
    },
    {
        path: "/rgpd/nov/ecotagri",
        name: "Confidentialité des données eCot'Agri - Sepac Compagri",
        component: RgpdNovSepacCompagri
    },
    {
        path: "/rgpd/fleet",
        name: "Confidentialité des données Fleet AgriVitech",
        component: rgpdFleet
    },
    {
        path: "/solutions/marketplace",
        name: "Marketplace",
        component: Marketplace
    },
    {
        path: "/solutions/marketplace/avm",
        name: "ViticulteursMarket",
        component: ViticulteursMarket
    },
    {
        path: "/solutions/marketplace/dtj",
        name: "DansTonJardin",
        component: DansTonJardin
    },
    {
        path: "/solutions/fleet",
        name: "Fleet",
        component: Fleet
    },
    {
        path: "/solutions/temoignagesclients/fleet",
        name: "Témoignages clients Fleet",
        component: FleetClients
    },
    {
        path: "/solutions/echangesemences",
        name: "EchangeSemences",
        component: EchangeSemences
    },
    {
        path: "/solutions/echangesemences/corporate",
        name: "EchangeSemencesCoop",
        component: EchangeSemencesCoop
    },
    {
        path: "/solutions/echangesemences/agriculteur",
        name: "EchangeSemencesAgri",
        component: EchangeSemencesAgri
    },
    {
        path: "/contact",
        name: "Contactez nous",
        component: ContactUs
    },
    {
        path: "/contact-demo",
        name: "Réservez une démo",
        component: ContactDemo
    },
    {
        path: "/actualites",
        name: "Actualités",
        component: News
    },
    {
        path: "/apropos",
        name: "A propos",
        component: Apropos
    },
    {
        path: "/agrivitechpourleclimat",
        name: "Actions pour le climat",
        component: Agrivitechpourleclimat
    },
    {
        path: "/jobs",
        name: "Emploi",
        component: Jobs
    },
    {
        path: "/actualites/bourse-vivescia",
        name: "Bourse Vivescia",
        component: BourseVivescia
    },
    {
        path: "/clients",
        name: "Nos Clients",
        component: Clients
    },
    {
        path: "/partner",
        name: "Partenaires",
        component: PartHome
    },
    {
        path: "/novacollecte/documentation",
        name: "Documentation NovaCollecte",
        component: DocNovaCollecte
    },
    {
        path: "/partners/home",
        name: "Compte partenaire",
        component: PartHome
    },
    {
        path: "/private",
        name: "Login2",
        component: Login2
    },
    {
        path: "/private/register",
        name: "Register",
        component: Register
    },
    {
        path: "/private/me",
        name: "Me",
        component: Me
    },
    {
        path: "/private/admin",
        name: "Admin",
        component: Admin,
        children: [
            {
                path: 'user/:id',
                component: User
            },
            {
                path: '',
                component: UserList
            }
        ]
    },
    {
        path: "/private/email-reset-password",
        name: "EmailResetPassword",
        component: EmailResetPassword
    },
    {
        path: "/private/reset-password/:token",
        name: "ResetPassword",
        component: ResetPassword,
    }
]

const router = createRouter({
    history,
    base: process.env.BASE_URL,
    routes,
    scrollBehavior() { window.scrollTo(0,0); }
})



export default router;